import Product from './Product';
import { useEffect, useState } from 'react';
import ProductsData from './data';
import axios from 'axios';
// axios.defaults.baseUrl = 'http://localhost:8080';
// axios.defaults.headers.common['Authorization'] =
//   'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRlbW9AZ21haWwuY29tIiwiaWF0IjoxNjc2NDkzNTI4fQ.VNWQDQJM9jDXrGofVLk3brpqlcNwFzjDmLLwfP9Rw4TM20IIuayvzubPJPfrkJb4kcRAUchdg7uy36rf9z-n9eLdcCw6FQLBBP7t0IA0NhFwjc0NjsJ50zUFgqPi8TAeVclD3DpjEoIRGbSrJpeVIBnLy6DeY7NcugJRbzKpW7iVq9WR9hO-mJ9n01zzEs3xJZ9Kyvq0dir680qPAtEdqLIvPstK8tDRNoYwcZXUthxSoDEAf-sp-E1qbuVv1WDlNpmBncWcUKFUgxeAuoFKRaYOy-9xrATE33C3wUW26Q9nUWJjDHiDw_Oe695P1UpTsKntGAWI_ECytTZhlA_pug';


// Initially we are rendering the data file.

// const ProductList = () => {
//   const [products, setProducts] = useState(ProductsData);  // if we use data which is present in our file
//   return (
//     <>
//       {products.map((product, index) => (
//         <Product {...product} key={index}></Product>
//       ))}
//     </>
//   );
// };


// Now we want to get the data from mongoDB server storage instead from local storage we need to use API call using
// fetch or axios
// To use axios we first install it as dependency
// Now note that both the node and react applications are running on different ports (8000 & 3000) respectively and we
// need to get data from nodeJS to react. So when two servers talk to each other(ie cross-origin) then due two security
// reasons it is not allowed. So we need to allow this from the server from which we are getting data and for this we
// need to use a middleware known as cors.
// Generally we do the API call under useEffect hook

// Now we will try CRUD operations on the mongoDB server database from the react UI.
// To add products we are using AddProduct file.
// Then to delete a product we used handleClick fn. Similarly we can do other operations of CRUD.

const ProductList = () => {

  const [products, setProducts] = useState([]);     // if we use cloud data
  // const [total, setTotal] = useState(0);

  const getProducts = async () => {
    const res = await axios.get('/products');
    // const res = await axios.get('http://localhost:8080/products');
    console.log(res.data);
    setProducts(res.data);
    // setTotal(res.data.length)
  };

  // below handleClick fn was created and passed to the Product file so that if we click on any product then it gets deleted
  // Here we need the id of the product
  // So here we did the delete operation. Similarly we can do the reamining operation like update and create etc

  const handleClick = async (id) => {
    const res = await axios.delete(`/products/${id}`);
    // const res = await axios.delete(`http://localhost:8080/products/${id}`);
    console.log(res.data);
    if (res.data._id) {
      setProducts(products.filter((p) => p._id !== res.data._id));
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <>
      {products.map((product, index) => (
        <Product {...product} key={index} handleClick={handleClick}></Product>
      ))}
    </>
  );
};

export default ProductList;


// Now we can see that our application have two parts node and react and are running at two differnt ports so to
// successfully run our applicatiion we need to combine react app into nodeJS (ie merge fronted and backened currently
// running at different url)
// The easiest way to merge is to make a build for the react part using a react command ie npm run build
// The build command transforms the react-app into normal JS file containing a static file and index.html. This can be
// verified by using react developer tool extension as it is no longer able to detect the react components so its no
// longer a react application.
// We can also host this build file by creating a server for this build file and request in browser. (Note - To build a
// static web server for any directory we can globally install http-server module using (npm i -g http-server)
// and use it. eg here after coming to the directory build, we just need to write http-server and it will make this
// directory (build) a web server.
// Now this transformed/compiled site can be used with the nodeJS. or it can also be uploaded to static hosting
// Note the the build code can't be edited. if we need to edit the code then we edit the original react code and again form
// the build file.